import { appConfig } from '../../../../../appConfig';
import type { ApiProduct } from '../../../../../models/ecommerce/product/ApiProduct';
import { mapVariantPriceData } from '../../../../common/models/domain/ecommerce/promotion/promotionMappers';
import type { ProductVariantProps } from '../../../../common/models/props/itemTeaserProps';
import { B2B_SEGMENT } from '../../../../common/utils/b2bUtils';
import { getCloudinaryUrl } from '../../../../common/utils/cloudinaryImageUtils';
import { mapProductToProps } from '../../../../common/utils/productUtils';
import { ensureLeadingSlash } from '../../../../common/utils/stringUtils';
import { buildAbsoluteUrl } from '../../../utils/urlEcommerceUtils';
import { addSwedishLabel } from '../../ProductInfoProperty/ProductInfoProperty.utils';
import type { ProductDetailsData } from './ProductDetailsPage.types';

export const mapToProductDetailsData = (
    product: ApiProduct,
    currentVariant: ProductVariantProps | undefined,
): ProductDetailsData => {
    const mapped = mapProductToProps(product);

    const productPriceData = mapVariantPriceData(
        {
            priceData: mapped.priceData,
            promotionPriceData: mapped.promotionPriceData,
            promotion: mapped.promotion,
        },
        currentVariant || undefined,
    );

    return {
        ...mapped,
        packageSizeInformation: currentVariant ? undefined : mapped.packageSizeInformation,
        priceData: productPriceData.priceData,
        promotionPriceData: productPriceData.promotionPriceData,
        promotion: productPriceData.promotion,
        attributeLabels: addSwedishLabel({
            fromSweden: mapped.fromSweden,
            attributeLabels: mapped.attributeLabels || [],
        }),
    };
};

export const getProductDetailsPageMetaData = (product: ProductDetailsData, isB2BRoute: boolean) => {
    let canonicalUrl = buildAbsoluteUrl(product.url);
    if (isB2BRoute) {
        canonicalUrl = canonicalUrl.replace(ensureLeadingSlash(B2B_SEGMENT), '');
    }

    return {
        canonicalUrl,
        ogImage: product.imageUrl
            ? getCloudinaryUrl(
                  product.imageUrl,
                  'e_sharpen,f_auto,fl_clip,fl_progressive,q_90,c_lpad,g_center,h_330,w_330',
                  appConfig.coopSettings.ecommerce.ogImage,
              )
            : undefined,
    };
};
